<template>
  <div>
    <app-bar :showtab="false">
      <template v-slot:title>Black BE云黑</template>
      <template v-slot:fun-icons>
        <user-login></user-login>

        <v-btn icon to="/search">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon @click="dark()">
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
      </template>
    </app-bar>
    <public @snackbar="snackbar" :key="'pub' + k"></public>
    <v-btn fab dark color="pink" @click="refresh" bottom right fixed>
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import userLogin from "@/components/content/userLogin/userLogin";
import Private from "@/components/content/List/Private";
import Public from "@/components/content/List/Public";
export default {
  name: "home",
  components: {
    AppBar,
    userLogin,
    Private,
    Public,
  },
  methods: {
    snackbar: function (e) {
      this.$emit("snackbar", e);
    },
    //list刷新
    refresh() {
      this.k++;
    },
    dark() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      window.localStorage.dark = this.$vuetify.theme.dark;
    },
  },
  data: function () {
    return {
      tab: null,
      k: 0,
      tabs: [{ title: "云黑公布" }],
    };
  },
};
</script>

<style></style>
